"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createSiteConfig = void 0;
var _image = _interopRequireDefault(require("./image"));
var _menu = _interopRequireDefault(require("./menu"));
var _searchInput = _interopRequireDefault(require("./search-input"));
var _utils = require("../utils");
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createFooterEndorsement = function createFooterEndorsement(_ref) {
  var footerEndorsementImage = _ref.footerEndorsementImage,
    footerEndorsementContent = _ref.footerEndorsementContent;
  if (footerEndorsementImage || footerEndorsementContent) {
    var content = footerEndorsementContent ? (0, _processRichText["default"])({
      document: footerEndorsementContent,
      factories: _standard["default"]
    }) : null;
    return {
      image: footerEndorsementImage ? (0, _image["default"])(footerEndorsementImage) : null,
      content: content
    };
  }
  return null;
};
var createSiteConfig = function createSiteConfig(_ref2) {
  var _fields$footerMenus;
  var fields = _ref2.fields;
  return {
    currencies: fields.currencies,
    footerLogos: fields.footerLogos ? fields.footerLogos.map(function (logo) {
      return (0, _image["default"])(logo);
    }) : null,
    mainMenu: fields.mainMenu ? (0, _menu["default"])(fields.mainMenu) : null,
    loggedInAccountMenu: fields.loggedInAccountMenu ? (0, _menu["default"])(fields.loggedInAccountMenu) : null,
    loggedOutAccountMenu: fields.loggedOutAccountMenu ? (0, _menu["default"])(fields.loggedOutAccountMenu) : null,
    footerEndorsement: createFooterEndorsement(fields),
    footerMenus: ((_fields$footerMenus = fields.footerMenus) === null || _fields$footerMenus === void 0 ? void 0 : _fields$footerMenus.length) > 0 ? fields.footerMenus.map(function (menu) {
      return (0, _menu["default"])(menu);
    }) : null,
    social: {
      facebook: (0, _utils.getProp)(fields, 'socialFacebookUrl'),
      twitter: (0, _utils.getProp)(fields, 'socialTwitterUrl'),
      instagram: (0, _utils.getProp)(fields, 'socialInstagramUrl'),
      youtube: (0, _utils.getProp)(fields, 'socialYoutubeUrl'),
      linkedin: (0, _utils.getProp)(fields, 'socialLinkedInUrl')
    },
    search: fields.search ? fields === null || fields === void 0 ? void 0 : fields.search.map(function (searchInput) {
      return (0, _searchInput["default"])(searchInput);
    }) : null,
    cancelOrderImage: fields.cancelOrderImage ? (0, _image["default"])(fields.cancelOrderImage) : null,
    cancelOrderContent: (0, _utils.getProp)(fields, 'cancelOrderContent'),
    cookieConsentContent: (0, _utils.getProp)(fields, 'cookieConsentContent'),
    discountSettings: (0, _utils.getProp)(fields, 'discountSettings') ? (0, _utils.getProp)(fields, 'discountSettings').filter(function (discount) {
      return discount.numberOfItems && discount.discountPercent;
    }) : [],
    featureFlags: (0, _utils.getProp)(fields, 'featureFlags', {})
  };
};
exports.createSiteConfig = createSiteConfig;
var siteConfigFactory = function siteConfigFactory(items) {
  return createSiteConfig(items.shift());
};
var _default = siteConfigFactory;
exports["default"] = _default;